import { useHomeHubQuestionSelector } from '@scenes/HomeHub/store/queries/useHomeHub.selectors';

/**
 * Each question module/selector should be encapsulated and get what it needs from the store(s).
 * ie: client/query
 *
 * There is a slight distraction here because we are using "local" client state to handle the "staging" of the answers.
 * But also using query state for BE state. We only get the BE state after an api has returned the update state.
 * @returns {any}
 */
const useHomeHubAnswerController = () => {
  /* Query Selector */
  const currentQuestion = useHomeHubQuestionSelector();

  /* Constants */
  const { selected_answers: selectedAnswers = [], answerSchemaNormalizer, answers, devices, grid_columns: gridColumn } = currentQuestion || {};

  return {
    gridColumn: gridColumn ?? 1,
    /* Normalize the answers so that the consumer can understand */
    answers: answers ?? [],
    devices: devices ?? [],
    answerSchemaNormalizer,
    selectedAnswers: answerSchemaNormalizer.selectedAnswers({ selectedAnswers, devices, answers }).read() ?? [],
    required: currentQuestion.required,
  };
};

export default useHomeHubAnswerController;
